import { paymentOptions, type PaymentOptions } from '../config/paymentOptions';

export const usePaymentOptions = () => {
  return {
    paymentOptions,
    loading: false,
    error: null
  };
}; 